import { render, staticRenderFns } from "./ApiResource.vue?vue&type=template&id=160deda9&scoped=true"
import script from "./ApiResource.vue?vue&type=script&lang=js"
export * from "./ApiResource.vue?vue&type=script&lang=js"
import style0 from "./ApiResource.vue?vue&type=style&index=0&id=160deda9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160deda9",
  null
  
)

export default component.exports